import moment from 'moment';
import { isActiveOrder } from './order';

export function validEmail(email) {
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
}

export function validMobile(number = '') {
  return number.replace(/\D/g, '').length >= 10;
}

export function validDate(date) {
  const time = Date.parse(date);
  return !isNaN(time);
}

export function underage(birthday) {
  const date = new Date(birthday);
  return moment().diff(date, 'years') < 21;
}

export function formatBirthday(birthday) {
  const normalized = birthday.replace(/-/g, '/');
  const date = new Date(normalized);
  return moment(date).format('YYYY-MM-DD');
}

export function displayBirthday(birthday) {
  if (!birthday) return '';
  const normalized = birthday.replace(/-/g, '/');
  const date = new Date(normalized);
  return moment(date).format('MM/DD/YYYY');
}

export function activeOrder(user) {
  if (!user || !user.orders || !user.orders[0]) return null;
  return isActiveOrder(user.orders[0]);
}



// WEBPACK FOOTER //
// ./shared/models/user.js